import { com } from '@eidu/web'
import EntityWithLabelAndRelated from '../domain/entity/EntityWithLabelAndRelated'
import Link from '../domain/entity/Link'
import assetResourceLinkKey = com.eidu.entity.assetResourceLinkKey
import assetResourceMimeLinkKey = com.eidu.entity.assetResourceMimeLinkKey

export const getResourceKeyFromEntity = (entity: EntityWithLabelAndRelated): string | undefined =>
  entity.entity.links.asJsReadonlyMapView().get(assetResourceLinkKey)

export const getEntityLinkFromResourceKey = (resourceKey: string): Link => ({
  key: assetResourceLinkKey,
  value: resourceKey,
})

export const getMimeTypeFromEntity = (entity: EntityWithLabelAndRelated): string | undefined =>
  entity.entity.links.asJsReadonlyMapView().get(assetResourceMimeLinkKey)

export const getEntityLinkFromMimeType = (mimeType: string): Link => ({
  key: assetResourceMimeLinkKey,
  value: mimeType,
})
